export default "__VITE_ASSET__69fe1c5b__"